"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderUpdateEventsValidation = exports.orderAddedEventsValidation = void 0;
const domain_1 = require("@oolio-group/domain");
const lodash_1 = require("lodash");
class AbstractValidator {
    setNext(validator) {
        this.nextValidator = validator;
        return validator;
    }
    validate(events, lastProcessedEvent) {
        if (this.nextValidator) {
            return this.nextValidator.validate(events, lastProcessedEvent);
        }
        return true;
    }
}
/**
 * validator: order events contains same orderId
 */
class OrderEventsOrderIdValidator extends AbstractValidator {
    validate(events, lastProcessedEvent) {
        if ((0, lodash_1.uniq)(events.map((item) => item.orderId)).length > 1) {
            return false;
        }
        return super.validate(events, lastProcessedEvent);
    }
}
/**
 * validator: order events should contains at least 2 events
 */
class OrderEventsLengthValidator extends AbstractValidator {
    validate(events, lastProcessedEvent) {
        if (events.length < 1) {
            return false;
        }
        return super.validate(events, lastProcessedEvent);
    }
}
/**
 * validator: order events should begin with initiate event
 */
class OrderEventsBeginWithEventValidator extends AbstractValidator {
    validate(events, lastProcessedEvent) {
        const [first] = events.slice(0, 1);
        if (first.action !== domain_1.OrderAction.ORDER_INITIATE &&
            first.action !== domain_1.OrderAction.ORDER_INITIATE_ONLINE &&
            first.action !== domain_1.OrderAction.ORDER_REFUND_INITIATE) {
            return false;
        }
        return super.validate(events, lastProcessedEvent);
    }
}
/**
 * validator: order events should end with save event
 */
const VALIDATED_END_EVENTS = [
    domain_1.OrderAction.ORDER_SAVE,
    domain_1.OrderAction.ORDER_PRINT_KITCHEN_DOCKET,
    domain_1.OrderAction.ORDER_INITIATE_ONLINE,
    domain_1.OrderAction.ORDER_ACCEPT,
    domain_1.OrderAction.ORDER_REJECT,
    domain_1.OrderAction.ORDER_COMPLETE,
    domain_1.OrderAction.ORDER_PARTNER_CANCEL,
    domain_1.OrderAction.ORDER_PLACED,
];
class OrderEventsEndWithEventValidator extends AbstractValidator {
    validate(events, lastProcessedEvent) {
        const [last] = events.slice(-1);
        if (!VALIDATED_END_EVENTS.includes(last.action)) {
            return false;
        }
        return super.validate(events, lastProcessedEvent);
    }
}
class OrderEventsCheckForPreviousValidator extends AbstractValidator {
    validate(events, lastProcessedEvent) {
        const eventsToBeValidated = events.filter(orderEvent => orderEvent.previous);
        if (!eventsToBeValidated.every(orderEvent => events.find(anyEvent => orderEvent.previous == anyEvent.id ||
            orderEvent.previous == lastProcessedEvent))) {
            return false;
        }
        return super.validate(events, lastProcessedEvent);
    }
}
const orderAddedEventsValidation = (events) => {
    const orderEventsLengthValidator = new OrderEventsLengthValidator();
    const orderEventsBeginWithEventValidator = new OrderEventsBeginWithEventValidator();
    const orderEventsEndWithEventValidator = new OrderEventsEndWithEventValidator();
    const orderEventsOrderIdValidator = new OrderEventsOrderIdValidator();
    const orderEventsCheckForPreviousValidator = new OrderEventsCheckForPreviousValidator();
    orderEventsLengthValidator
        .setNext(orderEventsBeginWithEventValidator)
        .setNext(orderEventsEndWithEventValidator)
        .setNext(orderEventsOrderIdValidator)
        .setNext(orderEventsCheckForPreviousValidator);
    return orderEventsLengthValidator.validate(events, '');
};
exports.orderAddedEventsValidation = orderAddedEventsValidation;
const orderUpdateEventsValidation = (events, lastProcessedEvent) => {
    const orderEventsLengthValidator = new OrderEventsLengthValidator();
    const orderEventsOrderIdValidator = new OrderEventsOrderIdValidator();
    orderEventsLengthValidator.setNext(orderEventsOrderIdValidator);
    return orderEventsLengthValidator.validate(events, lastProcessedEvent);
};
exports.orderUpdateEventsValidation = orderUpdateEventsValidation;
//# sourceMappingURL=eventValidator.js.map